<script setup lang="ts">
// @ts-expect-error raison: lib externe mal typée
import { defineProps } from 'vue';
import { useMarketCartStore } from '@/stores/cart.store';
import { formatAmount } from '@/utils/formatters';

const cart = useMarketCartStore();
const props = defineProps({
    layout: { type: String, default: 'none' },
    hideButton: { type: Boolean, default: false },
});

</script>
<template>
    <div class="widget s20 px-6 py-7">
        <h3 class="secondary-font text-grey-700 mb-5">Votre commande</h3>

        <h5 class="s10 secondary-font text-grey-700 mb-4">Sous-total</h5>
        <h5 class="s10 secondary-font text-grey-700 mb-4 text-right">{{ formatAmount(cart.getSubTotal) }} F</h5>
        <h5 class="s10 secondary-font text-red mb-4">Réduction</h5>
        <h5 class="s10 secondary-font text-red mb-4 text-right">-{{ formatAmount(cart.getTotalReduction) }} F</h5>
        <h5 class="s10 secondary-font text-grey-700 mb-4">TOTAL</h5>
        <h5 class="s10 secondary-font text-grey-700 mb-4 text-right">{{ formatAmount(cart.getTotal) }} F</h5>

        <div class="clear-both h-0"></div>
        <div class="s20 flex-center bg-color rounded-20 px-5 pt-4 pb-3">
            <h5 class="s10 secondary-font text-primary-color">Payer par mois</h5>
            <h5 class="s10 secondary-font text-primary-color text-right">{{ formatAmount(cart.getTotalEcheances) }} F</h5>
        </div>
        <div class="clear-both h-20"></div>
        <router-link :to="(layout == 'frontoffice' ? '/front/market/checkout' : '/market/checkout')" v-if="!hideButton">
            <button class="btn-ultra lg w-100"><!-- loading sm tips color2 light white white2 success info warning danger-->
                <div class="btn-show">
                    <span>&nbsp;Valider mon panier</span>
                </div>
                <div class="btn-loading">
                    <div class="loader-dots"></div>
                </div>
            </button>
        </router-link>
    </div>
</template>